module.exports = __webpack_public_path__ + "img/bible.2fd3fb93.png";